module.exports = __webpack_public_path__ + "static/media/error-red-filled.4c488d60.svg";